module.exports = __webpack_public_path__ + "/images/cover-it-acompanamiento.c91dc0a.jpg";